import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError } from "../services/apiService";

/* Get Sidebar Data Service*/
const getSidebarData = (params) => {
    const { axiosInstance ,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.permissios.getMenuPermission}`,
      method: "GET",
      params: params,
      withCredentials:config?.withCredentials,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };


  export default {
    getSidebarData,
}